'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data, range, mainScale) {
  var yMin = 0;
  var yMax = d3.max(data, function (d) {
    return Math.max(0, d.avgFare || 0, d.prevAvgFare || 0) * 1.05;
  });
  if (mainScale) {
    var mainScaleDomain = mainScale.yScale.domain();
    var mainYMax = mainScaleDomain[1];
    var mainYMin = mainScaleDomain[0];
    yMin = mainYMin * yMax / mainYMax;
  }
  var x = d3.scale.ordinal().domain(_.chain(data).map('clazz').uniq().value()).rangeBands([0, params.width], 0.1, 0.05);
  var y = d3.scale.linear().domain([yMin, yMax]).range([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;